export default "__VITE_ASSET__DYd7iuZg__$_?component__"